// 在整个完整页面中显示的路由定义在这里，如404页面、500页面、登录页等

// 老平台登录入口
const entrance = {
  path: '/entrance',
  name: 'entrance',
  component: (resolve) => require(['../components/entrance.vue'], resolve)
}

// 登录页面
const login = {
  path: '/login',
  name: 'login',
  component: (resolve) => require(['../components/login.vue'], resolve)
}

// 定义的路由需要添加到这个数组中
const pageRouters = [
  entrance,
  login
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/page-routers.js